import { Button } from '@mui/material'
import { Box } from '@mui/system'
import React, { useContext } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { RequestContext } from '../../Context/request'
import { axios } from '../../utils/axios';
import { AuthContext } from '../../Context/auth';

const ExecutiveHeader = () => {
    const location = useLocation();
    const { user } = useContext(AuthContext)
    const navigate = useNavigate()
    const userLogOut = () => {
        axios.get('/logout').then((res) => {
            sessionStorage.clear();
            navigate('/')
            window.location.reload()
        })
    }
    return (
        <Box sx={{ display: { xs: 'none', sm: 'flex !important' } }}>
            <Link to={'/executive/home'} className={`nav-link ${location?.pathname == "/executive/home" ? 'active' : ''}`} sx={{ color: '#fff' }}>
                Home
            </Link>
            <Link to={'/executive/create/patient-slip'} className={`nav-link ${location?.pathname == "/executive/create/patient-slip" ? 'active' : ''}`} sx={{ color: '#fff' }}>
                Create Slip
            </Link>
            {/* <Link to={'/executive/profile'} className={`nav-link ${('/executive/profile').includes(location?.pathname) ? 'active' : ''}`} sx={{ color: '#fff' }}>
                Profile
            </Link> */}
            <div className='userProfile'>
                {user?.email} <br />{user?.role}
            </div>
            <Button  onClick={userLogOut} className={`nav-link log-out ${location?.pathname == "/executive/logout" ? 'active' : ''}`} sx={{ color: '#fff' }}>
                Log Out
            </Button>
        </Box>
    )
}

export default ExecutiveHeader